import { Button } from '@/components/ui/button';
import { LinkedinIcon } from '@/components/icons/LinkedinIcon';
import { useAuth } from '@/lib/auth';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type LinkedInContinueButtonProps = React.ComponentProps<typeof Button>;

export function LinkedInContinueButton({
  className,
  ...props
}: LinkedInContinueButtonProps) {
  const { t } = useTranslation();
  const { loginWithLinkedIn } = useAuth({
    middleware: 'guest',
    redirectTo: '/',
    tmp: 'LinkedInContinueButton',
  });

  return (
    <Button
      type="button"
      variant="outline"
      className={cn(
        'h-[50px] w-full gap-2 rounded-[6px] border-border-strong bg-white font-label uppercase text-brand-secondary-dark hover:bg-brand-secondary-bright/5 dark:bg-card dark:text-foreground dark:hover:bg-muted dark:hover:text-foreground',
        className,
      )}
      onClick={() => loginWithLinkedIn()}
      {...props}
    >
      <LinkedinIcon className="h-4 w-4 shrink-0 text-[#0A66C2]" />
      {t('auth.linkedin.continueButton')}
    </Button>
  );
}
